// extracted by mini-css-extract-plugin
module.exports = {"version":"Version_version__2SOO_"};